import React, { useCallback, useMemo, useState, useEffect } from 'react';
import { MaterialReactTable } from 'material-react-table';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    MenuItem,
    Autocomplete,
    Stack,
    TextField,
    Tooltip,
} from '@mui/material';
import { Delete, Edit, Download } from '@mui/icons-material';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import api from '../api/axios';
import { htmlFollow } from "../constants/htmlCreation";
import moment from 'moment'

const lib = [
    'sim',
    'não',
]
const status_list = [ 'PENDENTE', 'VÁLIDA', 'EXPIRADA' ]

const CertificadoValida = () => {
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [tableData, setTableData] = useState({});
    const [userData, setUserData] = useState([])
    const [user, setUser] = useState([])
    const [param, setParam] = useState([])
    const [validationErrors, setValidationErrors] = useState({});

    const getUserList = async () => {
        await api.get('/user/list')
            .then(res => {
                res.data.map((item) => item.label = item.name)
                setUserData(res.data)
            })
            .catch(err => console.log(err))
    }

    const getUser = async (row) => {
        var ret
        console.log(row.getValue('user'))
        await api.get('/user/find/' + row.getValue('user'))
            .then(res => {
                setUser(res.data)
                console.log(res.data)
                ret = res.data
            })
            .catch(err => console.log(err))
        return ret
    }

    const getParam = async () => {
        var p
        await api.get('/param/list')
            .then(res => {
                setParam(res.data[0])
                p = res.data[0]
            })
            .catch(err => console.log(err))
        return p
    }

    useEffect(() => {
        (async () => {
            await getUserList()
            await api.get('/certificate/liststatus/VÁLIDA')
                .then(res => {
                    setTableData(res.data);
                    //console.log(res.data)
                })
                .catch(err => console.log(err))
        })();
    }, []);

    const handleCertificatePDF = async (row) => {
        var u = await getUser(row)
        var p = await getParam()
        //setTimeout('', 15000)
        console.log(u)
        const html = await htmlFollow(row, u, p)
        console.log('foi 0')
        var newwindows = window.open()
        console.log('foi 2')
        newwindows.document.write(html)

        setTimeout(function () {
            newwindows.print()
            newwindows.close()
        }, 1000)
    }

    const handleCreateNewRow = async (values) => {
        if (!values.user) {
            alert('Usuário é obrigatório!!!')
            return;
        }
        delete values._id
        delete values.date
        await api.post('/certificate/insert/', values)
            .then(res => {
                tableData.push(res.data);
                setTableData([...tableData]);
            })
            .catch(err => console.log(err))
    };

    const handleSaveRowEdits = async ({ exitEditingMode, row, values }) => {
        if (!Object.keys(validationErrors).length) {
            delete values.date
            tableData[row.index] = values;
            await api.put('/certificate/update/' + values._id, values)
                .then(res => {
                    tableData.splice(row.index, 1);
                    setTableData([...tableData]);
                })
                .catch(err => console.log(err))
            exitEditingMode(); //required to exit editing mode and close modal
        }
    };

    const handleCancelRowEdits = () => {
        setValidationErrors({});
    };

    const handleDeleteRow = useCallback(
        async (row) => {
            if (
                !window.confirm(`Confirmar exclusão de ${row.getValue('user')}`)
            ) {
                return;
            }
            try {
                const response = await api.delete('/certificate/delete/' + row.getValue('_id'));
                tableData.splice(row.index, 1);
                setTableData([...tableData]);
            } catch (error) {
                if (error.response) {
                    console.log(error.response.status);
                } else if (error.request) {
                    console.log(error.request);
                } else {
                    console.log('Error', error.message);
                }
            }
        },
        [tableData],
    );

    const getCommonEditTextFieldProps = useCallback(
        (cell) => {
            return {
                error: !!validationErrors[cell.id],
                helperText: validationErrors[cell.id],
                onBlur: (event) => {
                    const isValid =
                        cell.column.id === 'email'
                            ? validateEmail(event.target.value)
                            : cell.column.id === 'date'
                                ? cell.getValue()?.toLocaleDateString()
                                : validateRequired(event.target.value);
                    if (!isValid) {
                        //set validation error for cell if invalid
                        setValidationErrors({
                            ...validationErrors,
                            [cell.id]: `${cell.column.columnDef.header} is required`,
                        });
                    } else {
                        //remove validation error for cell if valid
                        delete validationErrors[cell.id];
                        setValidationErrors({
                            ...validationErrors,
                        });
                    }
                },
            };
        },
        [validationErrors],
    );

    const columns = useMemo(
        () => [
            {
                accessorKey: '_id',
                header: 'ID',
                enableColumnOrdering: false,
                enableEditing: false, //disable editing on this column
                enableSorting: false,
                size: 80,
            },
            {
                accessorKey: 'user',
                header: 'Usuário',
                enableEditing: false,
                size: 140,
                Cell: ({ cell }) => {
                    var x = userData.filter(user => (user._id === cell.getValue()))
                    if (x.length > 0) return x[0].name
                    else return ""
                },
                muiEditTextFieldProps: ({ cell }) => ({
                    children: userData.map((user) => (
                        <MenuItem key={user._id} value={user._id}>
                            {user.name}
                        </MenuItem>
                    )),
                    select: true,
                }),
            },
            {
                accessorFn: (row) => moment(new Date(row.date)).locale('pt_br').format('DD/MM/yyyy'), 
                accessorKey: 'date',
                header: 'Data',
                enableColumnOrdering: false,
                enableEditing: false, //disable editing on this column
                size: 80,
                muiEditTextFieldProps: ({ cell, row }) => moment(new Date(row.date)).locale('pt_br').format('DD/MM/yyyy'),
                //Cell: ({ cell }) => cell.getValue()?.toLocaleDateString(),
                //muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                //    ...getCommonEditTextFieldProps(cell),
                //    value: cell.getValue()?.toLocaleDateString()
                //}),
                filterVariant: 'date-range'

            },
            {
                //accessorFn: (row) => row.liberado ? 'sim' : 'não',
                accessorKey: 'status',
                header: 'Status',
                size: 80,
                muiEditTextFieldProps: ({ cell }) => ({
                    children: status_list.map((status) => (
                        <MenuItem key={status} value={status}>
                            {status}
                        </MenuItem>
                    )),
                    select: true,
                }),
            },
        ],
        [getCommonEditTextFieldProps, userData],
    );

    return (
        userData.length > 0 ? (
            <>
                <MaterialReactTable
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            muiTableHeadCellProps: {
                                align: 'center',
                            },
                            size: 120,
                        },
                    }}
                    columns={columns}
                    data={tableData}
                    editingMode="modal" //default
                    initialState={{ columnVisibility: { _id: false } }}
                    enableColumnOrdering
                    enableEditing
                    localization={MRT_Localization_PT_BR}
                    onEditingRowSave={handleSaveRowEdits}
                    onEditingRowCancel={handleCancelRowEdits}
                    renderRowActions={({ row, table }) => (
                        <Box sx={{ display: 'flex', gap: '1rem' }}>
                            <Tooltip arrow placement="left" title="Edit">
                                <IconButton onClick={() => table.setEditingRow(row)}>
                                    <Edit />
                                </IconButton>
                            </Tooltip>
                            <Tooltip arrow placement="right" title="Delete">
                                <IconButton color="error" onClick={() => handleDeleteRow(row)}>
                                    <Delete />
                                </IconButton>
                            </Tooltip>
                            <Tooltip arrow placement="right" title="Download">
                                <IconButton onClick={() => handleCertificatePDF(row)}>
                                    <Download />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    )}
                    renderTopToolbarCustomActions={() => (
                        <Button
                            color='warning'
                            onClick={() => setCreateModalOpen(true)}
                            variant="contained"
                        >
                            Criar Novo Certificado
                        </Button>
                    )}
                />
                <CreateNewAccountModal
                    columns={columns}
                    open={createModalOpen}
                    onClose={() => setCreateModalOpen(false)}
                    onSubmit={handleCreateNewRow}
                    users={userData}
                />
            </>) : <></>
    );
};

//example of creating a mui dialog modal for creating new rows
export const CreateNewAccountModal = ({ open, columns, onClose, onSubmit, users }) => {
    const [values, setValues] = useState(() =>
        columns.reduce((acc, column) => {
            acc[column.accessorKey ?? ''] = '';
            return acc;
        }, {}),
    );

    const handleSubmit = () => {
        //put your validation logic here
        onSubmit(values);
        onClose();
    };

    return (
        <Dialog open={open}>
            <DialogTitle textAlign="center">Criar Novo Certificado</DialogTitle>
            <DialogContent>
                <form onSubmit={(e) => e.preventDefault()}>
                    <Stack
                        sx={{
                            width: '100%',
                            minWidth: { xs: '300px', sm: '360px', md: '400px' },
                            gap: '1.5rem',
                        }}
                    >
                        {columns.map((column) => (
                            column.header != 'ID' && column.header != 'Data' ?
                                column.header === 'Usuário' ?
                                    <Autocomplete key={column.accessorKey}
                                        disablePortal
                                        id="combo-box-demo"
                                        onChange={(e, value) => setValues({ ...values, [column.accessorKey]: value._id })}
                                        options={users}
                                        renderInput={(params) => <TextField {...params} label="Usuário" />}
                                    /> :
                                    <Autocomplete key={column.accessorKey}
                                        disablePortal
                                        id="combo-box-demo"
                                        onChange={(e, value) => setValues({ ...values, [column.accessorKey]: value.label })}
                                        options={[{ label: 'PENDENTE' }, { label: 'VÁLIDA' }, { label: 'EXPIRADA' }]}
                                        renderInput={(params) => <TextField {...params} label="Status" />}
                                    /> : <></>
                        ))}
                    </Stack>
                </form>
            </DialogContent>
            <DialogActions sx={{ p: '1.25rem' }}>
                <Button onClick={onClose}>Cancelar</Button>
                <Button color="warning" onClick={handleSubmit} variant="contained">
                    Salvar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const validateRequired = (value) => !!value.length;
const validateEmail = (email) =>
    !!email.length &&
    email
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        );
const validateAge = (age) => age >= 18 && age <= 50;

export default CertificadoValida;

